import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout } from 'modules/layout';

export function RootRoute(): ReactElement {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
